import { createGlobalStyle } from 'styled-components';

import Aeroport from './woff/Aeroport.woff';
import Aeroport_Bold from './woff/Aeroport_Bold.woff';

const GlobalStyle = createGlobalStyle`

*,
  *:before,
  *:after {
     // box-sizing: border-box;
     margin: 0;
     padding: 0;
  }


  

@media (max-width: 800px) {
  html, body {
  overflow-x: hidden;
  }
}
@media screen and (min-width: 768px) {
  html, body {
    overflow-x: hidden;
  }
}


  html, body {

    

    width: 100vw;
  margin: 0; 
  padding: 0;
      //font-family: Ubuntu, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
     //overflow: hidden;
      text-rendering: optimizeLegibility;
  }
  
  
    
  
    @font-face {
        font-display: swap;
        font-family: 'Aeroport';
        src: local('Aeroport'), local('Aeroport'),
        url(${Aeroport}) format('woff');
        font-weight: 300;
        font-style: normal;
    }

    @font-face {
        font-display: swap;
        font-family: 'Aeroport_Bold';
        src: local('Aeroport_Bold'), local('Aeroport_Bold'),
        url(${Aeroport_Bold}) format('woff');
        font-weight: 300;
        font-style: normal;
    }

`;

export { GlobalStyle };
